import React, { useState } from "react";
import film from "../images/film.svg";
import {
  getFirestore,
  doc,
  setDoc,
  collection,
  getDocs,
} from "firebase/firestore";
import { app } from "../firbase/confing";
import { authUser } from "./Login";
import { NavLink } from "react-router-dom";
const db = getFirestore(app);
async function calcDataLength() {
  const querySnapshot = await getDocs(
    collection(db, authUser?.currentUser?.uid)
  );
  let sortArr = [];
  querySnapshot.forEach((data) => sortArr.push(data.id));
  return sortArr.length;
}
async function database(
  { url, description, directors, actors, type },
  callback
) {
  calcDataLength()
    .then((len) => {
      let date = new Date();
      const auth = authUser?.currentUser;
      const docid = `${description}${Math.floor(Math.random() * 1000)}`;
      const newCityRef = doc(db, auth.uid, docid);
      setDoc(newCityRef, {
        url: url,
        description: description,
        directors: directors,
        actors: actors,
        id: docid,
        type: type,
        sort: len,
        date: date.toDateString(),
        time: date.toLocaleTimeString(),
      });
    })
    .then(() => callback());
}
export default function Editupload() {
  const [state, setstate] = useState({
    url: "",
    text: "",
    directors: "",
    actors: "",
    radio: "",
  });
  const [iframe, setiframe] = useState(false);
  const [loading, setloading] = useState(false);
  const [sucess, setsucess] = useState(false);
  const link = state.url;
  const slice = link.slice(17);
  const URL = `https://www.youtube.com/embed/${slice}`;
  const handlechange = (e) => {
    const { name, value } = e.target;
    setstate({ ...state, [name]: value });
  };
  const load = () => {
    setloading(false);
    setsucess(true);
    document.getElementById("dbform").reset();
    setstate({
      url: "",
      text: "",
      directors: "",
      actors: "",
    });
  };
  const formsubmit = (e) => {
    e.preventDefault();
    setloading(true);
    const detail = {
      url: URL,
      description: state.text,
      directors: state.directors,
      actors: state.actors,
      type: state.radio,
    };
    database(detail, load);
  };

  return (
    <>
      <div
        style={{ top: `${sucess ? "3rem" : "-9rem"}` }}
        className="sucess-div"
      >
        <div
          className="alert alert-success p-2 alert-dismissible fade show"
          role="alert"
        >
          <strong>Created Sucessfully!</strong> check the link to visit{" "}
          <NavLink to="/dashboard/video" className="alert-link">
            Video
          </NavLink>{" "}
          {"  "}
        </div>
      </div>
      <div className="container mt-5 mb-5">
        <div className="row-col-1">
          {iframe ? (
            <div className="iframeborder p-1 mb-5">
              {state.url.length > 5 ? (
                <>
                  <div className="col parentIframe">
                    <iframe
                      className="iframe"
                      src={URL}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                  <div className="col mt-2 p-1 mb-1">
                    <h5 id="show-txt-description">
                      {state.text} | {state.directors.replace(/[,]/g, "-")} |{" "}
                      {state.actors.replace(/[,]/g, "-")}
                    </h5>
                  </div>
                </>
              ) : (
                <center>
                  <img src={film} width="250px" alt="film" />
                  <h5 className="mt-2 loadingerrortxt">
                    NO LINK TO BE PRESENTED
                  </h5>
                </center>
              )}
            </div>
          ) : (
            <></>
          )}
          <div className="col d-flex upload-form justify-content-center">
            <form onSubmit={formsubmit} id="dbform">
              <h6>YouTube Video Link</h6>
              <input
                type="url"
                pattern="https?://.+"
                name="url"
                value={state.url}
                onChange={handlechange}
                placeholder="https://youtube.com/..."
                title="https://youtube.com/..."
                required
              />
              <br />
              <br />
              <h6>Video Name Must Be Min-6</h6>
              <input
                type="text"
                name="text"
                placeholder="Video Name"
                pattern=".{6,}"
                value={state.text}
                onChange={handlechange}
                title="minimum 6 letter"
                required
              />
              <br />
              <br />
              <h6>Directors</h6>
              <input
                type="text"
                name="directors"
                placeholder="Directors"
                pattern=".{2,}"
                value={state.directors}
                onChange={handlechange}
                title="minimum 2 letter"
                required
              />
              <br />
              <br />
              <h6>Actors</h6>
              <input
                type="text"
                name="actors"
                placeholder="Actors"
                pattern=".{2,}"
                value={state.actors}
                onChange={handlechange}
                title="minimum 2 letter"
                required
              />
              <br />
              <br />
              <div>
                <p>
                  <input
                    type="radio"
                    name="radio"
                    onChange={handlechange}
                    value="Movie"
                    id="Movie"
                    required
                  />
                  <label htmlFor="Movie">Movie</label>
                </p>
                <p className="mt-2">
                  <input
                    type="radio"
                    name="radio"
                    onChange={handlechange}
                    value="Teaser"
                    id="Teaser"
                    required
                  />
                  <label htmlFor="Teaser">Teaser</label>
                </p>
              </div>
              <br />
              <br />
              <div>
                <button type="submit">
                  {loading ? (
                    <>
                      <span
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      <span
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      <span
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </>
                  ) : (
                    "CREATE"
                  )}
                </button>
                <button type="button" onClick={() => setiframe(!iframe)}>
                  Show Preview
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
